import { UserTablePropsGenerator } from "./UserTablePropsGenerator";
import { ownersKey } from "./model";

export const UserGroupInfoController = (
  description,
  businessFunction,
  noOfMembers,
  users,
  userGroupUniqueName,
  userGroupName,
  userGroupRepresentationName,
  userRoleKey,
  scope,
) => {
  const infoTabContainerId = `info-tab-${userRoleKey}`;

  const noOfMembersRenderProps = {
    key: "no-of-members",
    label: "No of members",
    value: noOfMembers,
  };

  const descriptionRenderProps = {
    key: "description",
    label: "Description",
    value: description,
  };

  const businessFunctionRenderProps = {
    key: "businessFunction",
    label: "Business function",
    value: businessFunction,
  };

  const defaultAccessScopeProps = {
    key: "defaultAccessScope",
    label: "Default access scope",
    value: scope,
  };

  const generalInfoProps = {
    leftSideRenderElements: [],
    rightSideRenderElements: [],
  };

  if (userRoleKey === ownersKey) {
    generalInfoProps.leftSideRenderElements.push(businessFunctionRenderProps);
    generalInfoProps.leftSideRenderElements.push(noOfMembersRenderProps);
    generalInfoProps.rightSideRenderElements.push(descriptionRenderProps);
    generalInfoProps.rightSideRenderElements.push(defaultAccessScopeProps);
  }

  const { isLoading, isErrorState, listOfTables, columnSelectProps } = UserTablePropsGenerator(
    users,
    userRoleKey,
    userGroupUniqueName,
    userGroupName,
    userGroupRepresentationName
  );

  return {
    isLoading,
    isErrorState,
    generalInfoProps,
    listOfTables,
    columnSelectProps,
    infoTabContainerId,
  };
};
